var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import gql from 'graphql-tag';
import { Card } from '@zillow/constellation';
import { ONSITE_MESSAGING_FRAGMENT, NFSOnsiteMessagingWrapper } from '@zillow/home-details-nfs-onsite-messaging';

var OmpHomeWorthUpsell = function OmpHomeWorthUpsell(_ref) {
  var property = _ref.property,
      abTests = _ref.abTests,
      additionalProps = _ref.additionalProps;
  var onsiteMessage = property.onsiteMessage;
  var triggerLocation = 'how_much_is_my_home_worth';
  var triggerObject = 'no_trigger_object';
  var triggerSource = 'top';
  return /*#__PURE__*/React.createElement(Card, {
    "data-testid": "hmimhw-omp-upsell-card",
    cardType: "secondary",
    padding: "sm",
    cardElevation: 0
  }, /*#__PURE__*/React.createElement(NFSOnsiteMessagingWrapper, {
    abBucket: abTests.HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING,
    messageData: onsiteMessage,
    additionalProps: additionalProps,
    placementName: "HMIMHWTopSlot",
    triggerLocation: triggerLocation,
    triggerObject: triggerObject,
    triggerSource: triggerSource
  }));
};

OmpHomeWorthUpsell.fragments = {
  // OmpHomeWorthUpsell fields can be found in HowMuchIsMyHomeWorthReviewQuery
  property: gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        fragment OmpHomeWorthUpsell_property on Property {\n            zpid\n            onsiteMessage(placementNames: [\"HMIMHWTopSlot\"]) {\n                ...onsiteMessage_fragment\n            }\n        }\n        ", "\n    "])), ONSITE_MESSAGING_FRAGMENT),
  abTests: gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        fragment OmpHomeWorthUpsell_abTests on ABTests {\n            HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING: abTest(\n                trial: \"HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING\"\n            )\n        }\n    "])))
};
export default OmpHomeWorthUpsell;
//# sourceMappingURL=OmpHomeWorthUpsell.js.map